/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { PreviewComponentAssets } from '../../../core/usecases';

/**
 * Ref. http://w3-engr/MyWorld/UserInterface/Hydra/Specs/STB/core_ux/elements/graphic_elements.html#star_rating
 * StarRating displays a row of star icons representing the given rating value.
 * Supports full, half, and empty stars for ratings between 0 and 4.
 * @param starRating - The numeric rating value (0-4).
 */
const StarRating: FunctionComponent<{ starRating?: number }> = ({ starRating = 0 }) => {
    if (!starRating || starRating <= 0) return null;
    const starRatingNames: Array<string> = ['', '', '', ''].fill('empty');

    let index = 0;
    let itrValue = starRating;
    while (itrValue > 0 && index < 5) {
        if (itrValue > 0 && itrValue < 1) {
            starRatingNames[index] = 'half';
        } else {
            starRatingNames[index] = 'full';
        }
        index += 1;
        itrValue -= 1;
    }

    const oPreviewAssets = new PreviewComponentAssets();
    const emptyStarUrl = oPreviewAssets.getImageAssetUrlById(
        PreviewComponentAssets.ImageAssets.EMPTY_STAR_ICON,
    );

    const fullStarUrl = oPreviewAssets.getImageAssetUrlById(
        PreviewComponentAssets.ImageAssets.FULL_STAR_ICON,
    );

    const halfStarUrl = oPreviewAssets.getImageAssetUrlById(
        PreviewComponentAssets.ImageAssets.HALF_STAR_ICON,
    );

    const getStarImages = () => {
        return starRatingNames.map((name, idx) => {
            if (name === 'full') return <img key={idx} src={fullStarUrl} className="star-icon" />;
            if (name === 'half') return <img key={idx} src={halfStarUrl} className="star-icon" />;
            return <img key={idx} src={emptyStarUrl} className="star-icon" />;
        });
    };

    return (
        <React.Fragment>
            <div className="uikit icons">{getStarImages()}</div>
        </React.Fragment>
    );
};

export default StarRating;
